import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import OverrideServerPropertiesIntro from './override-server-properties-intro.mdx';
import OverrideGeoIPPropertiesSDK from './override-geoip-properties-SDKs.mdx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <OverrideServerPropertiesIntro mdxType="OverrideServerPropertiesIntro" />
    <pre><code parentName="pre" {...{
        "className": "language-ruby"
      }}>{`posthog.get_feature_flag(
    'flag-key',
    'distinct_id_of_the_user',
    person_properties: {
        'property_name': 'value'
    },
    groups: {
        'your_group_type': 'your_group_id',
        'another_group_type': 'your_group_id',
    },
    group_properties: {
        'your_group_type': {
            'group_property_name': 'value'
        }
        'another_group_type': {
            'group_property_name': 'value'
        } 
    },
)
`}</code></pre>

    <OverrideGeoIPPropertiesSDK mdxType="OverrideGeoIPPropertiesSDK" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      